import { Chip, ChipProps, styled } from "@mui/material";
import React from "react";

import { MissionIncidentDisplayStatus } from "src/graphql-next/generated/types";

interface Props extends ChipProps {
  status: MissionIncidentDisplayStatus;
}

const StyledChip = styled(Chip)<{ status: MissionIncidentDisplayStatus }>`
  background-color: ${(props) => props.theme.palette.missionIncident.status[props.status]};
  color: ${(props) => props.theme.palette.common.white};
  span {
    font-weight: bold;
  }
`;

export const MISSION_INCIDENT_STATUS_LABEL: Record<MissionIncidentDisplayStatus, string> = {
  [MissionIncidentDisplayStatus.RequestTransmitted]: "Demande de devis transmise",
  [MissionIncidentDisplayStatus.InterventionScheduled]: "En attente d’intervention",
  [MissionIncidentDisplayStatus.Completed]: "Terminée",
};

export const ChipMissionIncident = ({ status, ...chipProps }: Props) => {
  return (
    <StyledChip status={status} label={MISSION_INCIDENT_STATUS_LABEL[status]} {...chipProps} />
  );
};
